import { createContext, ReactNode, useContext } from 'react';

interface InternalChatContextProps {
  isInternalChat: boolean;
}

const InternalChatContext = createContext<InternalChatContextProps>({
  isInternalChat: false,
});

export const InternalChatProvider = ({
  children,
  ...props
}: InternalChatContextProps & { children: ReactNode }) => (
  <InternalChatContext.Provider value={props}>
    {children}
  </InternalChatContext.Provider>
);

export const useInternalChatContext = () => {
  const context = useContext(InternalChatContext);
  return context;
};
